import { terminationReasonOptions } from '@/constants/termination-reasons'
import { FileInput } from '@/shared/components/file-input'
import { InputHelperText } from '@/shared/components/input-helper-text'
import { useCreateRequestContractTerminationMutation } from '@/store/services/employee-contract.service'
import { Button, Input } from '@material-tailwind/react'
import { useFormik } from 'formik'
import { useNavigate, useLocation } from 'react-router-dom'
import CustomSelect from '@/shared/components/custom-select'
import PropTypes from 'prop-types'
import { useEffect } from 'react'

const validate = (values) => {
  const errors = {}

  if (!values.new_changes.unlink_reason) {
    errors.new_changes = {
      unlink_reason: 'Motivo de desvinculación es requerido'
    }
  }

  return errors
}

export const RequestContractTerminationForm = ({ currentEmployee }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = location.search

  const initialValues = {
    id: currentEmployee.activeContract.id,
    new_changes: {
      unlink_date: '',
      unlink_reason: ''
    }
  }

  const [createRequestContractTermination, { isSuccess, isLoading }] =
    useCreateRequestContractTerminationMutation()

  const {
    errors,
    handleChange,
    handleSubmit,
    setFieldTouched,
    setFieldValue,
    submitCount,
    touched,
    values
  } = useFormik({
    initialValues,
    validate,
    onSubmit: createRequestContractTermination
  })

  const unlinkReasonError = errors.new_changes?.unlink_reason
  const showUnlinkReasonError =
    Boolean(unlinkReasonError) &&
    (Boolean(touched.new_changes?.unlink_reason) || submitCount > 0)

  useEffect(() => {
    if (isSuccess) {
      navigate(`/employees${searchParams}`)
    }
  }, [isSuccess])

  return (
    <form className='flex flex-col gap-4 p-1' onSubmit={handleSubmit}>
      <Input
        name='new_changes.unlink_date'
        onChange={handleChange}
        value={values.new_changes.unlink_date}
        label='Fecha de desvinculación'
        type='date'
        required
      />

      <CustomSelect
        placeholder='Motivo de desvinculación'
        required
        options={terminationReasonOptions}
        onChange={({ value }) =>
          setFieldValue('new_changes.unlink_reason', value)
        }
        onBlur={() => setFieldTouched('new_changes.unlink_reason', true)}
        value={terminationReasonOptions.find(
          (terminationReasonOption) =>
            terminationReasonOption.value === values.new_changes.unlink_reason
        )}
        menuPlacement='auto'
        menuPosition='fixed'
      />
      {showUnlinkReasonError && (
        <InputHelperText label={unlinkReasonError} color='red' />
      )}

      <FileInput
        text='Carga el documento asociado'
        handleChange={(file) => setFieldValue('attachment', file)}
        value={values.attachment}
      />

      <div className='flex justify-between'>
        <Button
          variant='text'
          color='gray'
          onClick={() => navigate(`/employees${searchParams}`)}
        >
          Cancelar
        </Button>

        <Button type='submit' loading={isLoading}>
          Enviar solicitud
        </Button>
      </div>
    </form>
  )
}

RequestContractTerminationForm.propTypes = {
  currentEmployee: PropTypes.object
}
